module.exports = __webpack_public_path__ + "img/login-two.cd50f7e8.png";